import { render, staticRenderFns } from "./pasosEliminarCuenta.vue?vue&type=template&id=f29429d8&scoped=true&"
import script from "./pasosEliminarCuenta.vue?vue&type=script&lang=js&"
export * from "./pasosEliminarCuenta.vue?vue&type=script&lang=js&"
import style0 from "./pasosEliminarCuenta.vue?vue&type=style&index=0&id=f29429d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29429d8",
  null
  
)

export default component.exports